const steps = [
  {
    num: '01',
    title: 'Discovery',
    desc: 'We deep-dive into your brand, audience, goals, and competitors to build a complete picture.',
  },
  {
    num: '02',
    title: 'Strategy',
    desc: 'We craft a tailored plan — channels, messaging, content pillars, and timelines — built to win.',
  },
  {
    num: '03',
    title: 'Execution',
    desc: 'Our team creates, launches, and manages every element with precision and creative excellence.',
  },
  {
    num: '04',
    title: 'Optimise',
    desc: 'We track performance, analyse results, and continuously refine for maximum impact.',
  },
];

const Process = () => (
  <section className="section process" id="process">
    <div className="container">
      <div className="section-header">
        <span className="section-tag">How We Work</span>
        <h2>Our <span className="red">Process</span></h2>
        <p>A proven framework that turns strategy into measurable growth.</p>
      </div>
      <div className="process-track">
        {steps.map((s, i) => (
          <div className="process-step" key={s.num}>
            <div className="process-num-wrap">
              <span className="process-num">{s.num}</span>
              {i < steps.length - 1 && <div className="process-line" />}
            </div>
            <div className="process-content">
              <h3>{s.title}</h3>
              <p>{s.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Process;
